import React from 'react';
import Home from './Home';
import About from './About';
import Project from './Project';
import Contact from './Contact';
import Experience from './Experience';
import MagicCursor from './MagicCursor';
/* Developed by Arul */
const Full = () => {
    return (
        <div className="home">
            <MagicCursor />
            <Home />
            <About />
            <Project />
            <Contact />
        </div>
    );
};

export default Full;
